module.exports = __webpack_public_path__ + "static/media/logo_bg_1000-min.1f259c34.png";